/**
 * plugins/divider.ts — Divisores de seção (.section-divider)
 *
 * Ferramentas: editar texto do badge central, ID de âncora.
 */

import { VtbPlugin, IVtbRegistry, SmartCtx, closestInside } from '../types';

export class DividerPlugin implements VtbPlugin {
    readonly panelId = 'vtb-divider';
    readonly selectorHints = ['div.section-divider', '.section-divider', '[data-vtb-id="section-divider"]'];

    detect(target: HTMLElement, visualEditor: HTMLElement): SmartCtx | null {
        const el = closestInside(target, visualEditor, e => 
            e.classList.contains('section-divider') || e.dataset.vtbId === 'section-divider'
        );
        if (!el) return null;
        return { type: this.panelId, label: 'Divisor de Seção', el };
    }

    activate(ctx: SmartCtx, registry: IVtbRegistry): void {
        const el = ctx.el;
        const textIn = registry.q<HTMLInputElement>('vtb-divider-text');
        const idIn   = registry.q<HTMLInputElement>('vtb-divider-id');

        const badge = el.querySelector('.sd-badge') || el.querySelector('[data-vtb-id="sd-badge"]');
        if (textIn && badge) {
            textIn.value = badge.textContent?.trim() || '';
        }

        if (idIn) {
            idIn.value = el.id || '';
        }
    }

    setup(registry: IVtbRegistry): void {
        registry.q('vtb-divider-apply')?.addEventListener('click', () => this._apply(registry));
    }

    private _apply(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx;
        if (!ctx) return;
        
        const text = registry.q<HTMLInputElement>('vtb-divider-text')?.value?.trim();
        const id   = registry.q<HTMLInputElement>('vtb-divider-id')?.value?.trim();
        
        if (text !== undefined) {
            const badge = ctx.el.querySelector('.sd-badge') || ctx.el.querySelector('[data-vtb-id="sd-badge"]');
            if (badge) badge.textContent = text;
        }

        if (id !== undefined) {
            if (id) ctx.el.id = id;
            else ctx.el.removeAttribute('id');
        }
        
        registry.sync();
    }
}
